import React from 'react';
import { Popover, PopoverProps } from 'react-aria-components';

import classNames from 'classnames';
import * as styles from './Menu.module.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
} & PopoverProps;

export const MenuPopover = ({ children, className, ...rest }: Props) => {
  const classes = classNames(styles.MenuPopover, className);
  return (
    <Popover className={classes} {...rest}>
      {children}
    </Popover>
  );
};
